import { useCallback } from 'react';
import { type NavigateOptions, useNavigate } from '@repo/poly-hooks/routing';
import { useCurrentOrganizationCore } from '#organization-core';

type OrganizationNavigation = (to: string, options?: NavigateOptions) => void;

export const useOrganizationNavigation = (): OrganizationNavigation => {
  const { slug } = useCurrentOrganizationCore();
  const navigate = useNavigate();

  return useCallback(
    (to, options) => {
      navigate(`/organizations/${slug}${to}`, options);
    },
    [navigate, slug]
  );
};
